var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 9,
    viewBox: "0 0 10 9",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9405 1.87508C8.08425 2.00285 8.09719 2.22296 7.96942 2.36671L4.25486 6.54559C4.18878 6.61993 4.09405 6.66247 3.99458 6.66247C3.89511 6.66247 3.80039 6.61993 3.73431 6.54559L1.87703 4.45615C1.74925 4.3124 1.7622 4.09229 1.90595 3.96451C2.0497 3.83674 2.26981 3.84969 2.39758 3.99343L3.99458 5.79006L7.44886 1.90399C7.57664 1.76025 7.79675 1.7473 7.9405 1.87508Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9405 1.87508C8.08425 2.00285 8.09719 2.22296 7.96942 2.36671L4.25486 6.54559C4.18878 6.61993 4.09405 6.66247 3.99458 6.66247C3.89511 6.66247 3.80039 6.61993 3.73431 6.54559L1.87703 4.45615C1.74925 4.3124 1.7622 4.09229 1.90595 3.96451C2.0497 3.83674 2.26981 3.84969 2.39758 3.99343L3.99458 5.79006L7.44886 1.90399C7.57664 1.76025 7.79675 1.7473 7.9405 1.87508Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.928639
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f28b9677a062e0e5bbe3e2cdc0dc78ec.svg";
export { ForwardRef as ReactComponent };